<template>
    <div>
        <h1 class="display-heading">{{ isOptometrist ? 'Practice Approval' : 'Clinic Approval' }}</h1>

        <div class="card mb-3">
            <div class="card-header">Approval Status</div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-3"><b>Review Status</b></div>
                    <div class="col-md-9">
                        <span class="badge text-nowrap" :class="{
                            'badge-success': isReviewed,
                            'badge-secondary': !isReviewed,
                        }">
                            {{ isReviewed ? 'Reviewed' : 'Not Review Yet' }}
                        </span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-3"><b>Approval Status</b></div>
                    <div class="col-md-9">
                        <template v-if="isReviewed">
                            <span class="badge text-nowrap" :class="{
                                'badge-success': isApproved && !isDisapproved,
                                'badge-danger': isDisapproved,
                            }">
                                {{ (isApproved && !isDisapproved) ? 'Approved' : 'Disapproved' }}
                            </span>
                        </template>
                        <template v-else>
                            <span class="badge badge-secondary text-nowrap">
                                Not Review Yet
                            </span>
                        </template>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3"><b>Update Approval</b></div>
                    <div class="col-md-9">
                        <button class="btn btn-primary btn-primary-insv mr-2"
                            @click="updateApproval(true)">Approve</button>
                        <button class="btn btn-primary btn-danger mr-2" @click="updateApproval(false)">Reject</button>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <table class="table table-bordered table-sm">
                <colgroup>
                    <col width="250">
                    <col>
                </colgroup>
                <tr>
                    <th colspan="2" class="text-uppercase">General Info</th>
                </tr>
                <tr>
                    <th>Join Date</th>
                    <td>{{ joinedDate }}</td>
                </tr>
                <tr>
                    <th>Email Address</th>
                    <td>{{ email }}</td>
                </tr>
                <tr>
                    <th>Phone Number</th>
                    <td>{{ phoneNo }}</td>
                </tr>
            </table>

            <table class="table table-bordered table-sm">
                <colgroup>
                    <col width="250">
                    <col>
                </colgroup>
                <tr>
                    <th colspan="2" class="text-uppercase">{{ isOptometrist ? 'Practice Info' : 'Clinic Info' }}</th>
                </tr>
                <tr>
                    <th>{{ isOptometrist ? 'Practice Name' : 'Clinic Name' }}</th>
                    <td>{{ name }}</td>
                </tr>
                <tr>
                    <th>Contact Person</th>
                    <td>{{ contactPersonDesignation + ' ' + contactPerson }}</td>
                </tr>
                <tr>
                    <th>{{ isOptometrist ? 'Practice Email Address' : 'Clinic Email Address' }}</th>
                    <td>{{ clinicEmail }}</td>
                </tr>
                <tr>
                    <th>{{ isOptometrist ? 'Practice Phone Number' : 'Clinic Phone Number' }}</th>
                    <td>{{ clinicPhone }}</td>
                </tr>
                <tr>
                    <th>Fax</th>
                    <td>{{ fax ? fax : '-' }}</td>
                </tr>
                <tr>
                    <th>Languages Speak</th>
                    <td>{{ languagesSpeak }}</td>
                </tr>
                <tr>
                    <th>Address</th>
                    <td>{{ `${(addressLine2 ? addressLine1 + ', ' + addressLine2 : addressLine1)}, ${addressCity},
                        ${addressPoscode} ${addressState}` }}</td>
                </tr>
                <tr>
                    <th>Coordinates</th>
                    <td>
                        <div class="row">
                            <div class="col-6">{{ "Latitude: " + lat }}</div>
                            <div class="col-6">{{ "Longitude: " + long }}</div>
                        </div>
                        <div class="place-map">
                            <div class="place-gmaps-wrapper">
                                <div :id="mapId" class="google-map" :style="{
                                    height: `${mapHeight}px`
                                }">
                                </div>
                                <div class="map-edit-cursor" :style="cursorPosition">
                                </div>
                                <div class="map-no-edit"></div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>Website</th>
                    <td>{{ website ? website : '-' }}</td>
                </tr>
                <tr>
                    <th>{{ isOptometrist ? 'Practice Registration (SSM) Number' : 'Clinic Registration (SSM) Number' }}</th>
                    <td>{{ clinicRegistrationNumber ? clinicRegistrationNumber : '-' }}</td>
                </tr>
                <tr>
                    <th>{{ isOptometrist ? 'Practice SSM Document' : 'Clinic SSM Document' }}</th>
                    <td>
                        <div v-if="!!ssmUpload.docFileNameGUID">
                            <div>
                                <a :href="`${clinicSupportingDocumentPath}${ssmUpload.docFileNameGUID}`"
                                    class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                            </div>
                        </div>
                        <div v-else class="font-italic">Not Uploaded</div>
                    </td>
                </tr>
                <!-- <tr>
                    <th>GST Registration Number</th>
                    <td>{{gstRegistrationNumber}}</td>
                </tr> -->
                <tr v-if="!isOptometrist">
                    <th>Borang B/F Number</th>
                    <td>{{ borangbNumber ? borangbNumber : '-' }}</td>
                </tr>
                <tr v-if="!isOptometrist">
                    <th>{{ isOptometrist ? 'Practice Borang B/F Document' : 'Clinic Borang B/F Document' }}</th>
                    <td>
                        <div v-if="!!borangBFUpload.docFileNameGUID">
                            <div>
                                <a :href="`${clinicSupportingDocumentPath}${borangBFUpload.docFileNameGUID}`"
                                    class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                            </div>
                        </div>
                        <div v-else class="font-italic">Not Uploaded</div>
                    </td>
                </tr>
                <tr v-if="!isOptometrist">
                    <th>Doctor Malaysian Medical Certificate (MMC) Number</th>
                    <td>{{ doctorMmcNumber }}</td>
                </tr>
                <tr v-if="!isOptometrist">
                    <th>{{ isOptometrist ? 'Practice Doctor MMC Document' : 'Clinic Doctor MMC Document' }}</th>
                    <td>
                        <div v-if="!!mmcUpload.docFileNameGUID">
                            <div>
                                <a :href="`${clinicSupportingDocumentPath}${mmcUpload.docFileNameGUID}`"
                                    class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                            </div>
                        </div>
                        <div v-else class="font-italic">Not Uploaded</div>
                    </td>
                </tr>
                <tr v-if="!isOptometrist">
                    <th>Doctor Annual Practitioner Certificate (APC) Number</th>
                    <td>{{ doctorApcNumber }}</td>
                </tr>
                <tr v-if="!isOptometrist">
                    <th>{{ isOptometrist ? 'Practice Doctor APC Document' : 'Clinic Doctor APC Document' }}</th>
                    <td>
                        <div v-if="!!apcUpload.docFileNameGUID">
                            <div>
                                <a :href="`${clinicSupportingDocumentPath}${apcUpload.docFileNameGUID}`"
                                    class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                            </div>
                        </div>
                        <div v-else class="font-italic">Not Uploaded</div>
                    </td>
                </tr>
                <tr>
                    <th>Facilities & Services</th>
                    <td>
                        <div class="row">
                            <template v-for="facilityAndService in facilitiesAndServices">
                                <div class="col-12 col-md-6" :key="facilityAndService">
                                    <li>
                                        {{ facilityAndService }}
                                    </li>
                                </div>
                            </template>

                        </div>
                        <span v-if="facilitiesAndServices.length === 0"> - </span>
                    </td>
                </tr>
                <tr v-if="!isOptometrist">
                    <th>Internet Provider</th>
                    <td>{{ internetProvider ? internetProvider : '-' }}</td>
                </tr>
                <tr>
                    <th>Working Days</th>
                    <td>
                        <div class="row">
                            <template v-for="workingDay in workingDays">
                                <div class="col-12 col-lg-6" :key="workingDay.workingDayId">
                                    <div class="row">
                                        <div class="col-5" style="font-style: italic;">
                                            <li>{{ getWorkingDayText(workingDay.workingDayId) }}</li>
                                        </div>
                                        <div class="col-7">
                                            <span>{{ workingDay.startTime }}</span>
                                            <span class="ml-2 mr-2">to</span>
                                            <span>{{ workingDay.endTime }}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>Operating Hours Special Remarks</th>
                    <td>{{ operatingHoursRemarks ? operatingHoursRemarks : '-' }}</td>
                </tr>
            </table>

            <table v-if="!isOptometrist" class="table table-bordered table-sm">
                <colgroup>
                    <col width="250">
                    <col>
                </colgroup>
                <tr>
                    <th colspan="2" class="text-uppercase">Bank Details</th>
                </tr>
                <tr>
                    <th>Bank Payee Name</th>
                    <td>
                        {{ bankAccountPayeeName }}
                    </td>
                </tr>
                <tr>
                    <th>Bank Name</th>
                    <td>
                        {{ bankName }}
                    </td>
                </tr>
                <tr>
                    <th>Bank Account Number</th>
                    <td>
                        {{ bankAccountNumber }}
                    </td>
                </tr>
            </table>

            <table v-if="isOptometrist" class="table table-bordered table-sm">
                <colgroup>
                    <col width="250">
                    <col>
                </colgroup>
                <tr>
                    <th colspan="2" class="text-uppercase">Optometrist Info</th>
                </tr>
                <tr>
                    <th>Full Name</th>
                    <td>{{ optoFullName }}</td>
                </tr>
                <tr>
                    <th>AMO Membership Number</th>
                    <td>{{ optoAmoMembershipNumber }}</td>
                </tr>
                <tr>
                    <th>AMO Membership Document</th>
                    <td>
                        <div v-if="!!optoAmoUpload.docFileNameGUID">
                            <div>
                                <a :href="`${clinicSupportingDocumentPath}${optoAmoUpload.docFileNameGUID}`"
                                    class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                            </div>
                        </div>
                        <div v-else class="font-italic">Not Uploaded</div>
                    </td>
                </tr>
                <tr>
                    <th>Qualification</th>
                    <td>{{ optoQualification }}</td>
                </tr>
                <tr>
                    <th>Awarding Institution</th>
                    <td>{{ optoAwardingInstitution }}</td>
                </tr>
                <tr>
                    <th>Registration Number</th>
                    <td>{{ optoMalaysiaOpticalCouncilRegistrationNumber }}</td>
                </tr>
                <tr>
                    <th>Registration Document</th>
                    <td>
                        <div v-if="!!optoMocUpload.docFileNameGUID">
                            <div>
                                <a :href="`${clinicSupportingDocumentPath}${optoMocUpload.docFileNameGUID}`"
                                    class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                            </div>
                        </div>
                        <div v-else class="font-italic">Not Uploaded</div>
                    </td>
                </tr>
            </table>

            <button class="btn btn-primary btn-primary-insv" @click="backToList">Back to List</button>
        </div>
    </div>
</template>

<script>
/* global google */
import {
    apiPath
} from '@/config';
import {
    convertDateToDDMMYYYY
} from '@/utilities';
import { googleMapsConfig } from '@/config/';
import { generateRandomId } from '@/utilities/';
export default {
    'name': 'DoctorApprovalDetails',
    'computed': {
        clinicId () {
            return this.$route.params.id;
        },
        mapHeight () {
            return this.mapWidth;
        },
        cursorPosition () {
            let cursorWidth = 48;
            let tipOffset = 20;

            return {
                'left': `${(this.mapHeight / 2) - (cursorWidth / 2)}px`,
                'top': `${((this.mapHeight / 2) - (cursorWidth / 2)) - tipOffset}px`
            };
        },
        clinicSupportingDocumentPath () {
            return `${apiPath}Profile/ClinicSupportingDocument?fileName=`;
        },
        isOptometrist () {
            return this.clinicType === 1;
        }
    },
    data () {
        return {
            'isApproved': false,
            'isReviewed': false,
            'isDisapproved': false,
            'name': '',
            'clinicPhone': '',
            'clinicEmail': '',
            'languagesSpeak': '',
            'clinicRegistrationNumber': '',
            'gstRegistrationNumber': '',
            'borangbNumber': '',
            'doctorMmcNumber': '',
            'doctorApcNumber': '',
            'facilitiesAndServices': [],
            'clinicType': 0,
            'optoFullName': '',
            'optoAmoMembershipNumber': '',
            'optoQualification': '',
            'optoAwardingInstitution': '',
            'optoMalaysiaOpticalCouncilRegistrationNumber': '',
            'lat': '',
            'long': '',
            'fax': '',
            'website': '',
            'addressLine1': '',
            'addressLine2': '',
            'addressCity': '',
            'addressState': '',
            'addressPoscode': '',
            'bankAccountPayeeName': '',
            'bankName': '',
            'bankAccountNumber': '',
            'contactPerson': '',
            'contactPersonDesignation': '',
            'internetProvider': '',
            'workingDays': '',
            'operatingHoursRemarks': '',
            'joinedDate': '',
            'email': '',
            'phoneNo': '',
            'mapId': '',
            'mapDom': null,
            'googleMapObj': null,
            'googleMapsAutoComplete': null,
            'mapWidth': '',
            'ssmUpload': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'borangBFUpload': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'mmcUpload': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'apcUpload': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'optoAmoUpload': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'optoMocUpload': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            }
        };
    },
    created () {
        this.mapId = generateRandomId();
    },
    mounted () {
        this.getClinic();
    },
    destroyed () {
        window.removeEventListener('resize', this.windowResizeHandler);
        window.removeEventListener('orientationchange', this.windowResizeHandler);
    },
    'methods': {
        getClinic () {
            this.axios.get('Clinic/GetClinic', {
                'params': {
                    'clinicId': this.clinicId
                }
            }).then(({ data }) => {
                const clinic = data.data;

                if (clinic.iar) {
                    this.isReviewed = true;
                    if (clinic.ia) {
                        this.isApproved = true;
                        this.isDisapproved = false;
                    } else {
                        this.isDisapproved = true;
                        this.isApproved = false;
                    }
                }

                this.name = clinic.n;
                this.email = clinic.e;
                this.phoneNo = clinic.mn;
                this.joinedDate = convertDateToDDMMYYYY(clinic.jd);
                this.languagesSpeak = clinic.ls;
                this.clinicRegistrationNumber = clinic.crn;
                this.gstRegistrationNumber = clinic.grn;
                this.lat = clinic.la;
                this.long = clinic.lo;
                this.fax = clinic.f;
                this.website = clinic.w;
                this.addressLine1 = clinic.a1;
                this.addressLine2 = clinic.a2;
                this.addressCity = clinic.ac;
                this.addressState = clinic.as;
                this.addressPoscode = clinic.ap;
                this.bankAccountPayeeName = clinic.bap;
                this.bankAccountNumber = clinic.ban;
                this.bankName = clinic.bn;
                this.contactPerson = clinic.cp;
                this.contactPersonDesignation = clinic.cpd;
                this.internetProvider = clinic.ip;
                this.workingDays = clinic.wd;
                this.operatingHoursRemarks = clinic.ohsr;
                this.facilitiesAndServices = clinic.fas ? clinic.fas.split(',') : [];
                this.borangbNumber = clinic.bbfn;
                this.doctorMmcNumber = clinic.dmmcn;
                this.doctorApcNumber = clinic.dapcn;
                this.clinicEmail = clinic.cne;
                this.clinicPhone = clinic.cnp;
                this.clinicType = clinic.ct;
                this.optoFullName = clinic.ofn;
                this.optoAmoMembershipNumber = clinic.oamn;
                this.optoQualification = clinic.oq;
                this.optoAwardingInstitution = clinic.oai;
                this.optoMalaysiaOpticalCouncilRegistrationNumber = clinic.omocrn;

                if (clinic.cssmd) {
                    this.ssmUpload.docFileNameGUID = clinic.cssmd.fg;
                    this.ssmUpload.docOriFileName = clinic.cssmd.fn;
                }

                if (clinic.bbfd) {
                    this.borangBFUpload.docFileNameGUID = clinic.bbfd.fg;
                    this.borangBFUpload.docOriFileName = clinic.bbfd.fn;
                }

                if (clinic.dmmcd) {
                    this.mmcUpload.docFileNameGUID = clinic.dmmcd.fg;
                    this.mmcUpload.docOriFileName = clinic.dmmcd.fn;
                }
                if (clinic.dapcd) {
                    this.apcUpload.docFileNameGUID = clinic.dapcd.fg;
                    this.apcUpload.docOriFileName = clinic.dapcd.fn;
                }

                if (clinic.oamd) {
                    this.optoAmoUpload.docFileNameGUID = clinic.oamd.fg;
                    this.optoAmoUpload.docOriFileName = clinic.oamd.fn;
                }

                if (clinic.omocd) {
                    this.optoMocUpload.docFileNameGUID = clinic.omocd.fg;
                    this.optoMocUpload.docOriFileName = clinic.omocd.fn;
                }

                window.addEventListener('resize', this.windowResizeHandler);
                window.addEventListener('orientationchange', this.windowResizeHandler);

                this.mapDOM = document.getElementById(this.mapId);
                this.mapWidth = this.mapDOM.getBoundingClientRect().width;

                this.initGoogleMaps();
            });
        },
        updateApproval (isApproved) {
            this.axios.post('clinic/UpdateClinicApproval', {
                'clinicId': this.clinicId,
                'isApproved': isApproved
            }).then(({
                data
            }) => {
                this.getClinic();
            });
        },
        backToList () {
            window.history.back();
        },
        getWorkingDayText (dayId) {
            switch (dayId) {
            case 1:
                return 'Monday';
            case 2:
                return 'Tuesday';
            case 3:
                return 'Wednesday';
            case 4:
                return 'Thursday';
            case 5:
                return 'Friday';
            case 6:
                return 'Saturday';
            case 7:
                return 'Sunday';
            }
        },
        initGoogleMaps () {
            this.googleMapObj = new google.maps.Map(this.mapDOM, googleMapsConfig);

            let isValidLat = this.lat > -90 && this.lat < 90;
            let isValidLng = this.long > -180 && this.long < 180;
            if (isValidLat && isValidLng) {
                if (this.googleMapObj) {
                    this.googleMapObj.setCenter({
                        'lat': parseFloat(this.lat),
                        'lng': parseFloat(this.long)
                    });
                };
            }
        },
        googleMapsResizeHandler () {
            if (this.googleMapObj) {
                google.maps.event.trigger(this.googleMapObj, 'resize');
            }
        },
        windowResizeHandler () {
            this.mapWidth = this.mapDOM.getBoundingClientRect().width;
        }
    }
};
</script>

<style scoped>
/*Place Detail*/
.place-map {
    margin-bottom: 1rem;
}

.place-map>.place-gmaps-wrapper {
    position: relative;
}

.place-map .map-edit-cursor {
    position: absolute;
    top: 0;
    width: 48px;
    height: 48px;
    background-image: url("../../assets/img/icons/location_edit.svg");
    background-size: 48px 48px;
    background-position: top left;
    background-repeat: no-repeat;
}

.place-map .map-no-edit {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

/*Place Detail*/
</style>
